import React from 'react';
import { connect } from 'react-redux';
import actionProps from 'actions';
import { Federation, Organization, Alumni } from 'resources';
import { RemoteSelect, Field, Form, SubmitButton } from 'components/form';

class AlumniRegisterIndex extends React.Component {

  handleSuccessSubmit() {
    this.props.actions.routePush('/alumni-registration/confirmation');
  }

  render() {
    return (
      <div className="account-wrapper account-wrapper-wide">

        <h3>Alumni registration</h3>

        <Form
          className="account-form account-body form-horizontal"
          action={Alumni.create}
          onSuccess={this.handleSuccessSubmit.bind(this)}
          autoComplete="off"
        >

          <Field name="alumni.federation_title" label="Fraternity or Sorority" inputSize={9}>
            <RemoteSelect
              resource={Federation}
              action="lookupList"
              query={`
                federation {
                  id
                  name
                }
              `}
              name="alumni.federation_title"
              display="name"
              placeholder="&mdash; select your organization &mdash;"
              identifier="name"
              fromKeyboard
            />
          </Field>

          <Field name="alumni.organization_title" label="School" inputSize={9}>
            <RemoteSelect
              resource={Organization}
              action="lookupList"
              name="alumni.organization_title"
              display="secondary"
              placeholder="&mdash; select your school &mdash;"
              selectFirst={false}
              identifier="secondary"
              fromKeyboard
            />
          </Field>

          <Field name="alumni.user.first_name" label="First name" inputSize={9}>
            <input
              type="text" name="alumni.user.first_name"
              className="form-control" placeholder="First name"
            />
          </Field>

          <Field name="alumni.user.last_name" label="Last name" inputSize={9}>
            <input
              type="text" name="alumni.user.last_name"
              className="form-control" placeholder="Last name"
            />
          </Field>

          <Field name="alumni.graduation_year" label="Graduation year" inputSize={9}>
            <input
              type="number" name="alumni.graduation_year"
              className="form-control" placeholder="Graduation year"
              maxLength="4"
            />
          </Field>

          <Field name="alumni.user.email" label="Email" inputSize={9}>
            <input
              type="text" name="alumni.user.email"
              className="form-control" placeholder="Email"
            />
          </Field>

          <div className="clearfix m-b-1">
            <SubmitButton>Register</SubmitButton>
          </div>

        </Form>

      </div>
    );
  }

}


export default connect(null, actionProps)(AlumniRegisterIndex);
